/**
 * Inicializa Microsoft Clarity para mapas térmicos y grabaciones de sesión
 * @param {string} projectId - ID del proyecto de Clarity
 */
export function initClarity(projectId) {
  if (typeof window === 'undefined' || !projectId) {
    return;
  }

  // Evitar inicialización múltiple
  if (window.clarity) {
    console.log('Clarity ya está inicializado');
    return;
  }

  // Script de inicialización de Clarity
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);

  console.log('✅ Microsoft Clarity inicializado');
}
